import React from 'react';

const LinkIcon = () => (
  <svg
    width={23}
    height={10}
    viewBox="0 0 23 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.74697 5C2.74697 3.29 4.26935 1.9 6.1422 1.9H10.5232V0H6.1422C3.11935 0 0.666016 2.24 0.666016 5C0.666016 7.76 3.11935 10 6.1422 10H10.5232V8.1H6.1422C4.26935 8.1 2.74697 6.71 2.74697 5ZM7.23744 6H15.9993V4H7.23744V6ZM17.0946 0H12.7136V1.9H17.0946C18.9674 1.9 20.4898 3.29 20.4898 5C20.4898 6.71 18.9674 8.1 17.0946 8.1H12.7136V10H17.0946C20.1174 10 22.5708 7.76 22.5708 5C22.5708 2.24 20.1174 0 17.0946 0Z"
      fill="#515151"
    />
  </svg>
);

export default LinkIcon;
